import { render, staticRenderFns } from "./WaysOfLearningSidebar.vue?vue&type=template&id=26aec9d1&scoped=true&"
import script from "./WaysOfLearningSidebar.vue?vue&type=script&lang=js&"
export * from "./WaysOfLearningSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WaysOfLearningSidebar.vue?vue&type=style&index=0&id=26aec9d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aec9d1",
  null
  
)

export default component.exports